import React from "react";
import { Label, Segment, Input } from "semantic-ui-react";
const InlineEditField = (props) => {
  const { label, value, hasFocus, handleChange, setFocus, setBlur, saveChange, type } = props;
  return (
    <Segment onBlur={setBlur}>
      {label && <Label color="red" ribbon>{label}</Label>}
      <Input
        type={type}
        defaultValue={value}
        onFocus={setFocus}
        onChange={e => handleChange(e.target.value)}
        className={hasFocus ? "inlineEdit hasFocus" : "inlineEdit"}
        title={"Click to edit"}
        style={{
          display: "block",
          fontSize: "1.8em",
          marginTop: "0em",
          textAlign: "center",
          padding: "0em"
        }}
      />
      {hasFocus && <Label as='a' corner='right' icon='save'></Label>}
      {!hasFocus && saveChange && <Label attached='top right' color="green">{saveChange}</Label>}
    </Segment>
  );
}
export default InlineEditField;